import React from 'react';
import { Chip } from '@/components/ui-ios';

const MAP = {
  PRESA_IN_CARICO:   { tone: 'neutral', label: 'Presa in carico' },
  IN_CONSEGNA:       { tone: 'blue',    label: 'In consegna' },
  CONSEGNATA:        { tone: 'green',   label: 'Consegnata' },
  GIACENZA:          { tone: 'amber',   label: 'Lasciato avviso' },
  RIFIUTATA:         { tone: 'red',     label: 'Rifiutata' },
  TRASFERITO:        { tone: 'amber',   label: 'Trasferito' },
  INDIRIZZO_ERRATO:  { tone: 'red',     label: 'Indirizzo errato' },
  DECEDUTO:          { tone: 'red',     label: 'Deceduto/a' },
  RITORNO_MITTENTE:  { tone: 'neutral', label: 'Ritorno mittente' },
  ERRORE:            { tone: 'red',     label: 'Errore' },
  // Legacy values (still rendered nicely while migration runs)
  CREATA:            { tone: 'neutral', label: 'Presa in carico' },
  IN_TRANSITO:       { tone: 'blue',    label: 'In consegna' },
};

export const ESITI_OPTIONS = [
  'PRESA_IN_CARICO',
  'IN_CONSEGNA',
  'CONSEGNATA',
  'GIACENZA',
  'RIFIUTATA',
  'TRASFERITO',
  'INDIRIZZO_ERRATO',
  'DECEDUTO',
  'RITORNO_MITTENTE',
  'ERRORE',
];

export const esitoLabel = (value) => (MAP[value] || MAP.PRESA_IN_CARICO).label;

export default function EsitoBadge({ value }) {
  const info = MAP[value] || MAP.PRESA_IN_CARICO;
  return <Chip tone={info.tone} testid="raccomandata-stato-badge">{info.label}</Chip>;
}
